"use client";

import { useState } from "react";
import { useTranslations } from "use-intl";

import { ArrowForwardIcon } from "@/components/appIcons";
import { Link } from "@/components/link";
import { BrowserPushInstallSteps } from "@/components/notifications/BrowserPushInstallSteps";
import { Button } from "@/components/ui/button";
import { useWebPushController } from "@/hooks/use-web-push-controller";
import { trackNotificationChannelSetupStarted } from "@/lib/analytics";
import { recordWebPushInstallIntent } from "@/lib/recordWebPushInstallIntent";

export function BrowserPushInstallRecovery({
  alerts,
}: {
  alerts: boolean;
  controller: ReturnType<typeof useWebPushController>;
}) {
  const t = useTranslations("browserPush");
  const [stepsVisible, setStepsVisible] = useState(false);

  if (!alerts) {
    return (
      <Link
        className="mt-5 inline-flex min-h-11 items-center gap-2 font-bold sm:min-h-10"
        to="/alerts"
      >
        {t("recoveryCta")}
        <ArrowForwardIcon decorative />
      </Link>
    );
  }

  return (
    <div className="mt-5">
      {stepsVisible ? (
        <BrowserPushInstallSteps />
      ) : (
        <Button
          className="min-h-12 w-full bg-[#e66a3a] px-5 font-black text-[#17130f] hover:bg-[#f17b4d] focus-visible:ring-[#e66a3a] sm:w-auto"
          onClick={() => {
            recordWebPushInstallIntent();
            trackNotificationChannelSetupStarted("web_push", "alerts_page");
            setStepsVisible(true);
          }}
          size="lg"
        >
          {t("installInstructionsCta")}
        </Button>
      )}
      <Link
        className="mt-4 inline-flex min-h-11 items-center gap-1 text-sm font-bold text-[#f4a17f] underline underline-offset-4 hover:text-[#ffc1aa] sm:min-h-10"
        hash="alerts-telegram"
        to="/alerts"
      >
        {t("otherChannelsCta")}
        <ArrowForwardIcon decorative />
      </Link>
    </div>
  );
}
